import merge from 'lodash/merge';

export const SET_USER = (state, user) => {
	state.user = user;
};

export const SET_USER_ACCESS = (state, { canRun, variantName }) => {
	merge(state.printos, { canRun, userAccess: variantName });
};
